<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="title" />
    <donut-rich-text v-model="adminString" />
    <div class="t m-tx1">{{ description }}</div>
    <donut-modal-sections-actions button-text="" cancel-text="Close" />
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();
  const $i18n = inject('$i18n');

  const featureName = $i18n.t('shoutouts.feature');
  const title = `Tell your admin about ${featureName}`;
  const adminString = computed(() => {
    const { admin } = state.modal.data;
    return [
      'Your Donut account admin is ',
      { type: 'link', text: admin.name, href: admin.link },
      '.',
    ];
  });
  const description = computed(() => {
    const suffix = state.currentTeam.premium_account ? ', already included in your Donut plan.' : '.';
    return `Let them know they can set up a rewards and recognition program in under five minutes with ${featureName}${suffix}`;
  });
</script>
